import type { ReactNode } from "react";
import React from "react";
import HelpIcon from "@rosette/web_components/src/icon/HelpIcon.js";
import { PopupButton } from "@/components/generic/popup/PopupButton.js";
import { cn } from "@rosette/ts/src/util/cn.js";


interface HelpButtonProps {
    className?: string;
    children: ReactNode;
}


export function HelpButton({ className, children }: HelpButtonProps) {
    return (
        <PopupButton
            buttonClassName={cn(
                "overflow-hidden bg-chip rounded-full p-[0.15em] mb-[0.1em] ml-2",
                "[&_svg]:fill-text-on-light [&_svg]:w-[0.85em] [&_svg]:h-[0.85em]",
                className ?? null,
            )}
            buttonContent={(
                <>
                    <HelpIcon />

                    <span className="sr-only">
                        Help
                    </span>
                </>
            )}>

            {children}
        </PopupButton>
    );
}
